var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-view-1014495",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14419",
    "data-name": "Path 14419",
    d: "M91.221,142.534c3.161,2.8,6.437,4.267,9.484,4.267s6.322-1.467,9.484-4.267a27.1,27.1,0,0,0,3.88-4.233,1.017,1.017,0,0,0,0-1.067,33.024,33.024,0,0,0-3.88-4.166c-3.161-2.8-6.437-4.267-9.484-4.267s-6.322,1.467-9.484,4.267a26.648,26.648,0,0,0-3.851,4.2,1.017,1.017,0,0,0,0,1.067,26.649,26.649,0,0,0,3.851,4.2Zm9.484-12.067c5.6,0,10.432,5.567,11.84,7.333-1.408,1.767-6.236,7.333-11.84,7.333s-10.432-5.567-11.84-7.333C90.273,136.034,95.1,130.468,100.705,130.468Z",
    transform: "translate(-87.22 -128.801)",
    fill: "#24abe2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14420",
    "data-name": "Path 14420",
    d: "M253.183,188.167c3.74,0,6.783-2.64,6.783-5.883s-3.043-5.883-6.783-5.883-6.783,2.64-6.783,5.883S249.443,188.167,253.183,188.167Zm0-10.177c2.713,0,4.95,1.94,4.95,4.293s-2.237,4.293-4.95,4.293-4.95-1.94-4.95-4.293S250.47,177.99,253.183,177.99Z",
    transform: "translate(-239.695 -173.283)",
    fill: "#24abe2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye__icon.596a9487cf2d99e17c1b6ebbc7517ab1.svg";
export { ForwardRef as ReactComponent };